import { Suspense, lazy, useState } from 'react'
import { logger } from './core/utils/Logger'
import { HUDContainer } from './ui/HUD/HUDContainer'
import { SceneManager } from './visualization/scene/GalaxyScene'

const ThreeCanvas = lazy(() => 
  import('./ui/components/ThreeCanvas').then(module => ({ default: module.ThreeCanvas }))
)

function App() {
  const [scene, setScene] = useState<SceneManager | null>(null);
  
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <Suspense fallback={
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#000',
          color: 'white',
          fontFamily: 'monospace'
        }}>
          Loading Bitcoin Space...
        </div>
      }>
        <ThreeCanvas 
          onSceneReady={(scene) => {
            logger.info('Galaxy scene ready', 'App');
            setScene(scene);
          }}
          style={{ width: '100%', height: '100%' }}
        />
      </Suspense>
      
      <HUDContainer scene={scene} />
    </div>
  )
}

export default App